export default __webpack_public_path__ + "static/media/line_bg_2.439ce627.png";